module.exports = __webpack_public_path__ + "static/media/points6_4.7106ea21.png";